/**
 * Aloqa havolalari. Qiymatlar admin panelda erkin matn bilan kiritiladi
 * ("+998 90 123-45-67", "@operator"), shuning uchun ishlatishdan oldin
 * tekshiriladi: noto'g'ri qiymat buzuq havola emas, BO'SH joy (tugma yo'q) beradi.
 */

/** `tel:` havolasi. 9 xonali raqam O'zbekiston raqami deb olinadi; 9 dan kam yoki 15 dan ko'p — rad. */
export function telUrl(raw: string): string | null {
  const digits = raw.replace(/\D/gu, '');
  if (digits.length === 9) return `tel:+998${digits}`;
  if (digits.length < 10 || digits.length > 15) return null;
  return `tel:+${digits}`;
}

/** Telegram foydalanuvchi nomi: "@name", "t.me/name" yoki "name". Telegram qoidasi: 5-32 belgi. */
export function telegramHandle(raw: string): string | null {
  const name = raw
    .trim()
    .replace(/^https?:\/\//iu, '')
    .replace(/^(?:www\.)?(?:t\.me|telegram\.me)\//iu, '')
    .replace(/^@/u, '');
  return /^[A-Za-z][A-Za-z0-9_]{4,31}$/u.test(name) ? name : null;
}

/**
 * `https://t.me/name` havolasi. `text` berilsa suhbat TAYYOR XABAR bilan ochiladi
 * ("Buyurtma #2481 bo'yicha savolim bor"): operator qaysi buyurtma/tovar haqida
 * ekanini darrov bilishi uchun mijoz uni qayta yozib o'tirmaydi.
 */
export function telegramUrl(raw: string, text?: string): string | null {
  const name = telegramHandle(raw);
  if (name === null) return null;
  const message = text?.trim() ?? '';
  return message === ''
    ? `https://t.me/${name}`
    : `https://t.me/${name}?text=${encodeURIComponent(message)}`;
}
